import { newSlice,_fetchEntitiesService,_loadEvents} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'pollPuntuationContactReports';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_POLL_CONTACT_REPORT_PUNTUATION";
  return _fetchEntitiesService(dataSlice,events);
}

